{
  "100": "Terms and Conditions",
  "101": "Privacy Policy",
  "102": "Encrypted communication",
  "107": "Do you use",
  "108": "ProtonMail",
  "109": "for your email? Then you don't have to do anything special. E-mail between users of ProtonMail is automatically encrypted.",
  "110": "If you use another e-mail service provider, you can use my public key to encrypt a message. The 16 characters you saw at the bottom of the homepage, is part of the ",
  "111": "digital fingerprint",
  "112": " of my public key. You can download the full public key below. You can also copy my full digital fingerprint via the clipboard.",
  "113": "Not familiar with PGP? Want to learn more about encrypting messages or files?",
  "116": "Or book an appointment with me and I will help you on your way.",
  "117": "Download Public Key",
  "118": "PGP Fingerprint Copy",
  "119": "TOR support",
  "120": "This website is also available through the TOR network (The Onion Router). Connections via TOR make it very difficult to find out your location and identity. You gain in privacy, but the loading of the site may be delayed.",
  "121": "To connect via Tor you use a special browser,",
  "122": "Tor Browser",
  "123": ", or a browser with built-in support for Onion addresses such as",
  "124": "Brave Browser",
  "126": "This site is also accessible via the Tor Network:",
  "127": "Lion Digits logo",
  "128": "Enterprise number",
  "129": "Email Joris Raymaekers",
  "130": "Email icon",
  "131": "Call me from Belgium",
  "132": "Phone Belgium icon",
  "133": "Call me from Spain",
  "134": "Phone Spain icon",
  "135": "Contact me via the Signal Messenger App",
  "136": "Signal Messenger App logo",
  "137": "Contact me via Skype",
  "138": "Skype logo",
  "139": "View my profile on Linked-In",
  "140": "Linked-In logo",
  "141": "View my profile on X",
  "142": "X logo",
  "143": "Check out the code I'm writing on Github",
  "144": "Github logo",
  "145": "Check out my visual creations on Codepen",
  "146": "Codepen logo",
  "147": "Copy to clipboard",
  "148": "Copy to clipboard icon",
  "149": "What is this?",
  "150": "Question mark icon",
  "152": "Signal Messenger App logo",
  "153": "external link icon",
  "154": "PGP introduction article",
  "155": "external link icon",
  "156": "download icon",
  "157": "Copy to clipboard icon",
  "158": "external link icon",
  "159": "external link icon",
  "160": "Book an appointment",
  "162": "Translate icon",
  "163": "Terms and Conditions",
  "164": "Last updated on 01-03-2022",
  "165": "Download the Lion Digits terms and conditions here:",
  "166": "Download Terms and Conditions",
  "167": "On this page you can read about the terms and conditions of Lion Digits. The descriptions on this page are indicative. Download the full terms and conditions for a complete overview.",
  "168": "Company details",
  "169": "Lion Digits: ICT consultant and developer of websites, web applications and software, and graphic design with registered office at:",
  "170": "and company number:",
  "171": "Offers",
  "172": "All quotations and offers by Lion Digits are entirely without obligation with regard to the client.",
  "173": "Advice, proposals and quotations made by Lion Digits are personally addressed to the client. Without the permission of Lion Digits, it is not permitted to provide these for inspection to other parties or to use them other than to assess the offer.",
  "174": "Lion Digits is only bound by the offers if the acceptance thereof is confirmed in writing by the client within 14 days.",
  "175": "An agreement is concluded as soon as the offer is signed by the client and received by Lion Digits, and as soon as the advance payment of 25% of the total amount has been received.",
  "176": "Only if it is stated on the quotation that no advance payment is expected, the agreement will be concluded as soon as the quotation has been signed by the client.",
  "177": "Guarantee",
  "178": "A warranty period of 30 calendar days starts after the delivery of a project. This warranty period allows to solve errors or bugs within the quotation.",
  "179": "The right to warranty lapses if the customer wishes to access an account that can make structural changes to the website or to the code, such as a superuser account of a website, access to the core file system by means of (S)FTP or access with write rights to the database systems used.",
  "180": "Additional guarantees can be determined within the framework of a maintenance contract.",
  "181": "Liabilities",
  "182": "In the event of an attributable shortcoming in the fulfillment of the agreement, Lion Digits is only liable for replacement compensation up to the invoice amount. Any liability of Lion Digits for any other form of damage is excluded, including compensation for indirect damage, consequential damage or damage due to loss of turnover or profit.",
  "183": "Prices",
  "184": "All prices quoted are exclusive of VAT, unless expressly stated otherwise.",
  "185": "Extra wishes of the client that have not been agreed in advance will result in additional work for which Lion Digits will have to be compensated proportionally.",
  "186": "All prices are indexed annually, unless agreed otherwise in writing between the parties.",
  "187": "Payment",
  "188": "After completion of the assignment, Lion Digits will send an invoice for the amount involved in the agreement, less any previously paid advance payment. The client must pay the amount due within 14 days after the invoice date.",
  "189": "If the client has exceeded the payment term, Lion Digits will send a reminder for payment. The costs of a reminder, worth € 30 excluding VAT, will be charged to the client.",
  "190": "If the client has not fulfilled his obligations within 14 days after sending the first reminder, the collection will be outsourced. All costs resulting from this are for the account of the client. If it concerns a website or other online services, these will also be taken offline after the same exceeding period of 14 days. Costs for possibly bringing the website back online afterwards are entirely for the client.",
  "191": "Privacy",
  "192": "Lion Digits collects and processes the personal data and company data it receives from the client for the purpose of the execution of the agreement, customer management, purchases, accounting and direct marketing activities. The legal grounds are the performance of an agreement, the fulfillment of legal and regulatory obligations and/or the legitimate interest.",
  "194": "← Home",
  "195": "download icon",
  "196": "Read the privacy policy",
  "199": "Hey, watch out!",
  "200": "You shouldn't be here...",
  "201": "back",
  "207": "book an appointment",
  "211": "Smart entrepreneurs",
  "212": "are well aware of the importance of a well-designed web presence, how that presence can appeal to their target audience and convert the resulting leads into",
  "213": "additional revenue",
  "219": "Want to know more about who I am? Looking for someone with technical competencies in JavaScript, TypeScript, NodeJs or ReactJs? Curious about the brains behind the technology? Read more about my story and discover the power of my technical skills.",
  "220": "Read more...",
  "223": "Visit website",
  "224": "technical fiche",
  "225": "A new website was built for the beer brand Goudster from Halen, with a handy overview of the brewery's long history and a module for ordering online.",
  "226": "Visit website",
  "227": "The customer base of Brasserie Lemmensmolen in Beverlo got a boost after launching an elegant website with an online reservation module.",
  "228": "Visit website",
  "230": "Visit website",
  "231": "technical features",
  "232": "Interested? Let's talk!",
  "233": "Let us chat to explore how I can help you and how we can best work together. Schedule an appointment online right now.",
  "234": "book an appointment",
  "235": "Triangle icon",
  "236": "Pyramid icon",
  "237": "Hourglass icon",
  "238": "Photo of Joris Raymaekers",
  "239": "JavaScript logo",
  "240": "JavaScript",
  "243": "TypeScript logo",
  "244": "TypeScript",
  "248": "Demo video of the Catacamp website",
  "249": "Visit the Catacamp website",
  "250": "catacamp logo",
  "251": "external link icon",
  "252": "View the code on GitHub",
  "253": "Github logo",
  "255": "Demo video of the Goudster website",
  "256": "Visit the Goudster website",
  "257": "Goudster logo",
  "258": "external link icon",
  "259": "Home page of Brasserie Lemmensmolen",
  "260": "Home page of Brasserie Lemmensmolen",
  "261": "Visit the website of Brasserie Lemmensmolen",
  "262": "Lemmensmolen logo",
  "263": "external link icon",
  "265": "Demo video of the Travel Agency website",
  "266": "Visit the Clear View Escape website",
  "267": "Clear View Escape logo",
  "268": "external link icon",
  "269": "View the code on Github",
  "270": "Github logo",
  "272": "Lion Digits, web development",
  "273": "Privacy Policy",
  "274": "Last updated on 01-03-2022",
  "275": "| General provisions",
  "276": "On this page you can read what data is collected when you use this website or interact with Lion Digits, why this data is collected and how it improves your user experience.",
  "277": "This privacy policy applies to the services of Lion Digits. Lion Digits cannot be held responsible for the privacy practices of other sites and resources you come into contact with through this website.",
  "278": "By using this website or communicating with Lion Digits, you indicate acceptance of this privacy policy.",
  "279": "Communication",
  "280": "When you send e-mail or other messages to us, we may retain those messages. Note that some (customer) data must be kept for administrative, legal or security purposes. Sometimes you will be asked for additional personal information that is relevant to the situation in question. This makes it possible to process your questions and answer your requests. This data is stored on Lion Digits' own secure servers or those of a third party.",
  "281": "Cookies",
  "282": "Functional cookies",
  "283": "This website uses \"cookies\", small text files that are placed on your computer to help the website function better and faster. For example, to remember the language choice.",
  "284": "Most browsers are set to accept cookies by default, but you can reset your browser to refuse all cookies or to indicate when a cookie is being sent. However, some features and services on this and other websites may not function properly if cookies are disabled in your browser.",
  "285": "Analytical cookies",
  "286": "Cookies can also be used to analyze how users use the site. The information generated by the cookie about your use of the website may be transferred to Lion Digits' own secure server or that of a third party. This information is used to keep track of how you use the website and to compile reports on website activity.",
  "287": "This information will only be used for the purposes described in this privacy policy.",
  "288": "Embedded content from other sites",
  "289": "Information on this site may contain embedded content (e.g. videos, images, messages, etc.). Embedded content from other sites behaves exactly the same as if the visitor had visited this other site. These sites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including recording interactions with the embedded content on this site.",
  "290": "Access personal information and contact details",
  "291": "All visitors have the opportunity to view, change, or delete all personal information provided to Lion Digits.",
  "292": "e-mail",
  "293": "← Home",
  "296": "About me...",
  "297": "Joris Raymaekers",
  "301": "Books, roses and freedom",
  "302": "A day through the streets of Barcelona to measure the temperature of the Catalan political process.",
  "303": "Read on Doorbaak.be",
  "305": "Developing technology and using it as a lever to increase your personal or business impact is something I am very happy to help with.",
  "312": "From design to code",
  "313": "front-end development",
  "314": "Github-page",
  "316": "example",
  "317": "example",
  "318": "example",
  "321": "Layouts and visual animations can be done in almost all possible configurations. A selection of examples and experiments can be found on my Codepen:",
  "322": "Codepen front-end mini-projects",
  "323": "Collections include: forms with client-side validation, image galleries with DOM element filtering, modals, and CSS animations...",
  "324": "Codepen Profile",
  "333": "Server management and cloud services",
  "334": "magic behind the scenes",
  "337": "example",
  "338": "example",
  "339": "example",
  "343": "development environment",
  "344": "Applications are developed using a development environment or IDE, Integrated Development Environment. A collection of programs and tools to write and test your code.",
  "351": "Fun Zone",
  "352": "Okay, enough reading. Below you will find a number of mini projects and games that will keep you entertained for a while. Have fun!",
  "353": "Guess the Flag",
  "354": "Play now",
  "355": "Task Manager",
  "356": "To the app",
  "357": "Stenographer",
  "358": "To the app",
  "359": "Patatap",
  "360": "Play now",
  "361": "The player is presented with a random country flag and four possible answers. Try to choose the right one. Built game state management with ReactJs and pulled data from REST-Countries API.",
  "362": "Single page task management app with custom JSON API. Main UI feature: Select multiple items (shift key), delete and update a custom selection of tasks. Application built with NodeJs, Express & MongoDb. API endpoints for GET/POST/PUT/DELETE requests. AJAX requests with jQuery.",
  "364": "Tap, click or type randomly on your keyboard. Each keystroke produces a firework of randomly generated sounds and colors. Application built with PaperJs and HowlerJs libraries.",
  "368": "Photo of Joris Raymaekers",
  "369": "Visit the MS-DOS Games Archive",
  "370": "external link icon",
  "371": "Casa Pedrera Barcelona",
  "372": "Doorbraak logo",
  "373": "JavaScript logo",
  "374": "JavaScript",
  "377": "TypeScript logo",
  "378": "TypeScript",
  "381": "To the Github repository",
  "382": "external link icon",
  "383": "See an example on Github",
  "384": "external link icon",
  "385": "See an example on Github",
  "386": "external link icon",
  "387": "See an example on Github",
  "388": "external link icon",
  "389": "See an example on Github",
  "390": "external link icon",
  "392": "Codepen profile snapshot",
  "393": "Codepen logo",
  "394": "View code snippet on my Github profile",
  "395": "external link icon",
  "396": "View code snippet on my Github profile",
  "397": "external link icon",
  "398": "View code snippet on my Github profile",
  "399": "external link icon",
  "401": "Guess the country from the flag",
  "402": "Technical details...",
  "403": "Question mark icon",
  "405": "Image of the Task Manager app",
  "406": "Technical details...",
  "407": "Question mark icon",
  "409": "Image from the Stenographer app",
  "410": "Technical details...",
  "411": "Question mark icon",
  "413": "Image of the Patatap app",
  "414": "Technical details...",
  "415": "Info icon",
  "418": "Read more about the privacy policy,",
  "419": "You can send questions or requests regarding the processing of your data via",
  "420": "or send a letter to the address below.",
  "422": "Lion Digits | Powerful digital tech. By Joris Raymaekers.",
  "423": "here",
  "424": "Tailored advice for your web presence",
  "426": "Website development, maintenance and optimization",
  "427": "Cross-platform web apps with ReactJs and React Native",
  "428": "Server app development with NodeJs",
  "430": "Nginx configuration:",
  "431": "Docker Compose configuration:",
  "432": "Bash script for automatic code updates to VPS server:",
  "435": "Taiga",
  "436": "external link icon",
  "437": "until that too changes.",
  "440": "external link icon",
  "441": "Taiga.io, open source agile project management software",
  "443": "Version 1.0,",
  "444": "Version 1.0,",
  "445": "(1983, Herk-de-Stad)",
  "447": "image of digital services",
  "453": "Website Text Translator (WTT)",
  "454": "Check out the NPM module at NPMjs.com",
  "455": "WTT",
  "459": "View the code on Github",
  "461": "Demo website van CataCamp",
  "463": "Read the full article on the website of Doorbraak...",
  "464": "Mail, Text, Phone, etc.",
  "465": "other options...",
  "466": "IT services & About myself",
  "467": "Digital tailor-made solutions",
  "468": " Need a website or web app? Looking for a freelance IT guy? This is the place to be!",
  "474": "Demo video",
  "475": "Demo video",
  "476": "Demo video",
  "477": "Signal",
  "481": "ProtonMail",
  "483": "PGP: Pretty Good Privacy",
  "484": " This website uses cookies to provide an optimal experience. ",
  "485": "More info...",
  "486": "Got it",
  "487": "business icon",
  "488": "Key icon",
  "489": "Tor Network icon",
  "490": "Onion-service URL",
  "491": "Matthew 6",
  "492": "9 After this manner therefore pray ye: Our Father which art in heaven, Hallowed be thy name. 10 Thy kingdom come, Thy will be done in earth, as it is in heaven. 11 Give us this day our daily bread. 12 And forgive us our debts, as we forgive our debtors. 13 And lead us not into temptation, but deliver us from evil: For thine is the kingdom, and the power, and the glory, for ever. Amen.",
  "496": "Find out what I know about Bitcoin...",
  "499": " But the digital world is not the be-all and end-all and it was said a long time ago: ",
  "500": ". So in my spare time you will regularly find me walking in nature with the dog and strength training keeps me fit and strong. I also like to kick a ball sometimes.",
  "501": "mens sana in corpore sano",
  "502": " In a previous chapter I was active as a logistics employee; love then took me to Catalonia; and a Masters in Comparative Politics led to an episode in journalism. For those who like to read and, like me, have a warm heart for Catalonia, below you will find a selection of my own publications from the olden days:",
  "503": "Casa de les Punxes, Barcelona",
  "504": " The Homework of the Catalans (Part I)",
  "505": " Joris Raymaekers, one of our Doorbraak employees in Barcelona, measures the political temperature in Catalonia.",
  "507": "Parliament of Catalonia, hemicycle",
  "508": " The Homework of the Catalans (Part II)",
  "509": " The ongoing Catalan process of national transition is gradually transforming the Catalan political landscape.",
  "512": "Read more...",
  "513": " Web application for listing camping sites in Catalonia. This project covers the entire 'full web stack': a backend API with database and a front-end web app. Click through to the technical sheet for more details.",
  "514": " Website for travel agency Clear View Escape. Click through to the technical sheet for more details.",
  "515": "View my profile on Nostr",
  "516": "Nostr logo",
  "517": "View my profile on Instagram",
  "518": "Instagram logo",
  "519": " The most user-friendly way to send encrypted messages is via the Signal Messenger app: ",
  "520": "Signal",
  "521": " This free and open-source messaging app offers end-to-end encryption to send messages, photos, videos, and calls. Signal only asks for your phone number when you first register with the service. No metadata surrounding communications is stored. The app also allows messages to be automatically cleared once read.",
  "522": "Add me as a contact in Signal via this link:",
  "523": "Signal Contact",
  "524": "Send me a",
  "525": "e-mail",
  "526": "Read one here",
  "527": "introduction",
  "528": "Bitcoin accepted here logo",
  "529": "Bitcoin accepted here logo",
  "530": "Bitcoin logo",
  "531": "Bitcoin logo",
  "532": "Pay in bitcoin? Yes you can!",
  "533": " Bitcoin is an interesting experiment and a different way of dealing with money. I find it very interesting to follow from both a technical and monetary perspective and I am therefore willing to accept it as a means of payment.",
  "534": " Bitcoin is accessible to everyone, but probably not everyone's cup of tea.",
  "535": ". ",
  "536": " I am not a promoter of bitcoin nor a financial advisor and I will never spontaneously contact or bother anyone about it",
  "537": " There is a lot of confusing and incorrect information circulating about bitcoin and what is called 'crypto'. Please inform yourself thoroughly and if you are looking for a starting point, I humbly make two free suggestions:",
  "538": "Bitcoin for Everybody —",
  "539": "[Saylor Academy]",
  "540": " Bitcoin for Everybody is a course (12 hours) with a good overview of the history, basic ideas and concepts surrounding bitcoin. After completing the course you can receive a certificate like mine: Saylor Academy",
  "541": "certificate",
  "542": "Bitcoin is... —",
  "543": "[Case Bitcoin]",
  "544": " You can approach bitcoin from multiple angles: digital gold, a breakthrough in computer science, a currency of and for the internet, an economic experiment, a speculative investment, etc. CaseBitcoin makes the case for bitcoin from different perspectives and also has a handy overview of the most common concerns and",
  "545": "critics",
  "546": " The document that started it all ",
  "547": ", by the anonymous Satoshi Nakamoto can you find ",
  "548": ". ",
  "549": "Bitcoin: A Peer-to-Peer Electronic Cash System",
  "550": "in this pdf file",
  "551": "React logo",
  "552": "React",
  "553": "Node.js logo",
  "554": "Node.js",
  "555": "My first experience with computers and computer code came from fixing cranky video games in the MS-DOS command line. Never heard of MS-DOS? Back then, it was like",
  "556": "this...",
  "557": " What started as a hobby with configuring games and repairing PCs and telephones has now evolved into building complete web applications.",
  "558": " But I don't work with computers for myself. I get the most satisfaction and pleasure from helping others alleviate and overcome their IT concerns and challenges.",
  "559": " In addition to my work on the web, I am also fascinated by cryptography and the possible applications with digital keys for security or new forms of money and payments such as ",
  "560": "bitcoin",
  "561": ". Hence the references to things such as ",
  "562": "What I can do for you",
  "563": " Personalized advice to ensure that your online presence exactly matches your goals and vision.",
  "564": " Create dynamic and modern web apps using JavaScript's extensive ecosystem of libraries and the latest digital tools.",
  "566": " Expertise in building and managing WordPress websites with DIVI and WP-Bakery for a seamless and flexible experience.",
  "567": " Powerful and user-friendly cross-platform web applications using the latest technologies such as React and React Native.",
  "568": " Leverage the speed and scalability of Node.js to build robust server applications with JavaScript.",
  "569": " Are you technically inclined? Then be sure to scroll further for an overview of my technical skills. Check out some examples, follow the Github links to source code, or browse through the featured creations on Codepen...",
  "570": "Technical skills",
  "571": " An overview of my technical competencies",
  "572": "Code icon",
  "573": "Code icon",
  "574": "Git branch icon",
  "575": "Git branch icon",
  "576": "Laptop icon",
  "577": "Laptop icon",
  "578": "File icon",
  "579": "File icon",
  "580": "Front-end Development",
  "581": "Backend Development",
  "582": "Servers & Cloud Services",
  "583": "Programming languages",
  "584": "IDE & Project Management",
  "585": "UI/UX implementation",
  "586": " Many websites — including this very site, are designed with a design program such as AdobeXd or Figma and then converted to the code of the web in HTML5, (S)CSS and JavaScript. Special attention is paid to ",
  "587": " approach and a logical division of the code into sections and components using a methodologie like Block-Element-Modifier ",
  "588": "mobile-first",
  "589": "An example of what this looks like in practice can be found in the source code for this website on this ",
  "590": "Front-end & JavaScript libraries",
  "591": " Development is (sometimes) faster if you can build on the work of others. Libraries contain pre-programmed and tested components, layouts and functions that are easily reusable. For example, the scrolling animations on this website are powered by the AOS (Animation-On-Scroll) library. Some other examples of libraries I'm familiar with:",
  "592": "Bundle and optimize",
  "593": " Managing all the design code, images, and scripts that come with a sizable website can quickly become a daunting task. To manage and optimize all these sources, I use specialized tools such as ParcelJS, Webpack or GulpJS. See an example with GulpJS on",
  "594": "Github",
  "595": "React",
  "596": " Modern interactive user interfaces can become quite complex and you often need an advanced JavaScript library such as React that tries to make building and managing UI components efficient and scalable.",
  "597": "See a simple example on",
  "598": "my Github",
  "599": "Or watch the live version here",
  "600": "Go to the Cooking-react app",
  "601": "link",
  "602": " Server-side apps en API's ",
  "603": " development with Node.js",
  "604": " Node.js is a solid open source runtime environment for JavaScript. It is a very versatile environment in which to build applications that can then be run on just about any platform. JavaScript is the language of the web and via Node.js you can use the same programming language for both the user interface (UI) and the logic for the server or backend tasks.",
  "605": " In combination with TypeScript — a superset of JavaScript, Node.js allows you to build very solid and high-performance programs. From web apps and REST APIs to Command Line applications and test solutions.",
  "606": "Examples of Node.js projects",
  "607": " is a Node.js NPM module with a Command Line Interface. The program helps you translate the text of existing HTML files via the Google Translate API and then integrate and manage them into your website using JSON files. The CLI interface is built with Commander and the parsing of HTML elements is done with Node-HTML-Parser. This program, with accompanying documentation, is available as open source software in the NPM registry: ",
  "608": ". ",
  "609": " is a project built in Node.js with an ExpressJS server, a REST API, authentication with PassportJS and Redis for session storage. Other data is stored in a MongoDB database using Mongoose for object modeling (ODM). View the code on ",
  "610": " or a working demo version via the ",
  "611": "CataCamp",
  "612": "Github",
  "613": "Catacamp website.",
  "614": "Domain and DNS configuration",
  "615": " Your web app must be accessible via a server and a domain name. Configuring domain names and DNS (Domain Name System) settings with subdomains, email and SSL certificates is a task that comes with every website. For optimally efficient availability of the website, a CDN (Content Delivery Network) can also be set up.",
  "616": "Server management",
  "617": " Server and system administration is not my main activity, but I am skilled in setting up and maintaining virtual servers (VPS) for both Node.js apps and Wordpress websites. Working with and configuring instruments such as Nginx (reverse proxy), PM2 process manager, Tmux SSH sessions or Docker containers is part of my skills.",
  "618": " When working in the command line and with servers, you often encounter the same types of tasks that you can automate using Bash scripts and cron jobs. Some examples of Bash scripts and configurations can be found via the links below:",
  "619": "Cloud features and cloud services",
  "620": ", ",
  "621": ", ",
  "622": ", of ",
  "623": " Cloud functions are part of 'serverless architectures' where the management of the server infrastructure is outsourced to cloud services such as",
  "624": "To AWS Amazon Lambda",
  "625": "Amazon AWS Lambda",
  "626": "To Google Cloud Functions",
  "627": "Google Cloud Functions",
  "628": "To Microsoft Azure Functions",
  "629": "Microsoft Azure Functions",
  "630": "To Netlify",
  "631": "Netlify",
  "632": ". Benefits include scalability, cost efficiency and reduced maintenance, but",
  "633": "The real benefits and drawbacks of Cloud Functions",
  "634": "the cons",
  "635": "include vendor lock-in and potential challenges with latency and debugging.",
  "636": "An example of a simple cloud function can be found on my",
  "637": "Github",
  "638": "Programming languages",
  "639": "Python logo",
  "640": "Python logo",
  "641": "PHP logo",
  "642": "PHP logo",
  "643": "JavaScript",
  "644": " My focus is on JavaScript and by extension TypeScript — a commonly used superset of JavaScript in the context of front-end development with React.",
  "645": " I learned to write my first lines of JavaScript code using the book Eloquent JavaScript by Marijn Haverbeke. Not the simplest beginner's book, but rigorous. ",
  "646": "Eloquent JavaScript by Marijn Haverbeke",
  "647": "Eloquent JavaScript",
  "648": " On my own Github page you will find a number of repositories with notes, exercises and programming challenges that testify to my own learning process:",
  "649": "JavaScript notes",
  "650": "JavaScript notes",
  "651": "Programming Challenges I",
  "652": "Programming Challenges I",
  "653": "— incl. Jest Unit Testing",
  "654": "Programming Challenges II",
  "655": "Programming Challenges II",
  "656": "— incl. Jest Unit Testing",
  "657": "Python",
  "658": " Python is rightly praised for its elegance and simplicity and it is a programming language that I increasingly enjoy experimenting with. Check out some projects such as a todo app and some mini-games, in this ",
  "659": "Python tryouts",
  "660": "Github repo",
  "661": " Want to learn Python? \"Learn Python the Right Way\" is a modern online adaptation of the book \"How to Think Like a Computer Scientist\" focusing on fundamental concepts as well as practical examples and projects.",
  "662": "Learn Python the Right Way",
  "663": "Learn Python the Right Way",
  "664": "PHP",
  "665": " As a web developer you also regularly come into contact with PHP. In the case of WordPress, PHP is the main programming language used to develop themes, plugins and other functionalities. I'm familiar with the syntax and most common concepts, but when it comes to server-side applications I'm more familiar with Node.js.",
  "666": " IDE, dev tools and project management",
  "667": "IDE",
  "668": " My basic configuration consists of a Windows Subsystem for Linux (WSL2) and Visual Studio Code, supplemented with various extensions and plugins for, for example, Docker or the automatic formatting of code according to the rules of the trade with Prettier. And since the rise of AI, plugins such as Tabnine AI or Github Co-pilot have also added value in order to work faster.",
  "669": "Version control",
  "670": " As a web developer, not only do I master the basics of Git, my workflow also includes using",
  "671": " with a cryptographic key for extra security and the use of a standardized",
  "672": " to (try to) ensure consistent and informative commits. Example on my",
  "673": ". ",
  "674": "signed commits",
  "675": "commit template",
  "676": "Github-pagina",
  "677": " You can discuss endlessly about Git branching models and work flows, but one of the clearest blog posts is one from the old days: ",
  "678": " by Vincent Driessen (2010).",
  "679": "A successful Git branching model",
  "680": " Github is of course an extremely effective interface on top of Git, but for my individual projects I also use Gitea whereby I manage some of the code on my own server.",
  "681": "Project management",
  "682": " I am familiar with Enterprise solutions such as Jira, but for personal projects I prefer a Kanban workflow via",
  "683": "View the code on Github",
  "684": "View the code on Github",
  "685": " Hide a text message in an image. Encode and decode an image of your choice. Built with Python and React.",
  "686": "View the code on Github",
  "687": "View the code on Github",
  "688": "Building and managing Wordpress websites",
  "689": "Visit the blog post of Vincent Driesen",
  "690": "Signal Messenger",
  "691": "Add Signal contact",
  "692": "To ProtonMail Website",
  "693": "Download Tor Browser",
  "694": "Download Brave Browser",
  "695": " TOR or Onion links are long combinations of numbers and letters that end with a \".onion\". You can recognize the Lion Digits address by the first six characters: \"http://liondig... .onion\":",
  "696": "Open this Onion link in a browser with TOR support",
  "697": "Saylor Academy",
  "698": "Certificate Joris Raymaekers",
  "699": "Website Case Bitcoin",
  "700": "Criticism of bitcoin",
  "701": "Wait, there's more...",
  "702": "Snow",
  "703": "IT Services",
  "704": "Bitcoin and energy",
  "705": "KPMG report about Bitcoin mining",
  "706": "[KPMG about 'mining' Bitcoin]",
  "707": "Attention to bitcoin also continues to increase from institutional and corporate angles. More and more companies, large and small, realize that in addition to the wild price fluctuations and all the craziness of 'crypto' speculators, there is indeed a basis for new and serious business models. This report from KPMG is an example of this:",
  "708": "Bitcoin’s role in the ESG imperative",
  "709": "The Rise of bitcoin",
  "710": "home page",
  "711": "← Home",
  "712": "Home page",
  "713": "← Home",
  "714": " tailor-made for you...",
  "715": "Powerful tech",
  "716": " development with special attention to best practices, privacy and security.",
  "717": "Pixel-perfect web app",
  "718": " with the tools of the web: HTML, CSS, JavaScript, ReactJs and NodeJs (or Python).",
  "719": "Freelance programming work",
  "720": " Analysis, help and advice for your web presence:",
  "721": " to increase your business impact.",
  "722": " IT as leverage",
  "723": "Joris Raymaekers",
  "724": "has extensive experience in creating relevant and user-friendly web applications and enjoys helping entrepreneurs exceed their goals.",
  "725": " Book a free online consultation here online to explore how we can work together and strengthen each other.",
  "726": "Examples of successful achievements with ",
  "727": "satisfied customers...",
  "728": "Description of the functions of the website",
  "729": "Learn more about BEM",
  "730": "(BEM)",
  "731": "Pretty Good Privacy (PGP)",
  "732": "or TOR Onion Router services which you will find at the very bottom of this page.",
  "733": "Find out how I use encrypted communications...",
  "734": " is an open-source front-end snowflakes animation library that you can easily integrate into an existing website. With a few simple lines of JavaScript you get an HTML5 Canvas animation with snowflakes and tons of options, including customizable toggle buttons that allow the website visitor to turn the animation on or off. View the detailed description and documentation on the ",
  "735": " or view the code in the ",
  "736": "Snowfall-js-plugin",
  "737": "NPM page",
  "738": "Github-repo."
}
